import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core';
import type { AsyncOptions } from './useAsyncOptions';
import { OptionsFeedback } from './OptionsFeedback';
import { useCreationStyles } from './useCreationStyles';

interface CreationSelectProps<T> {
  id: string;
  label: string;
  query: AsyncOptions<T>;
  value: string;
  onChange: (value: string) => void;
  optionValue: (item: T) => string;
  optionLabel: (item: T) => string;
  optionKey: (item: T) => string;
  feedbackLabel: string;
  loadingText: string;
  disabled?: boolean;
  error?: string;
  branch?: boolean;
}
function options<T>(props: CreationSelectProps<T>) {
  if (props.query.status === 'loading')
    return (
      <MenuItem value="" disabled>
        {props.loadingText}
      </MenuItem>
    );
  return props.query.items.map(item => (
    <MenuItem key={props.optionKey(item)} value={props.optionValue(item)}>
      {props.optionLabel(item)}
    </MenuItem>
  ));
}
export function CreationSelect<T>(props: CreationSelectProps<T>) {
  const classes = useCreationStyles();
  return (
    <FormControl
      variant="outlined"
      size="small"
      fullWidth
      className={classes.field}
      error={props.branch ? undefined : !!props.error}
    >
      <InputLabel id={`${props.id}-label`}>{props.label}</InputLabel>
      <Select
        labelId={`${props.id}-label`}
        label={props.label}
        value={props.value}
        onChange={e => props.onChange(e.target.value as string)}
        disabled={props.disabled || props.query.status === 'loading'}
      >
        {options(props)}
      </Select>
      <OptionsFeedback query={props.query} label={props.feedbackLabel} />
      {props.error && (
        <FormHelperText error={props.branch ? true : undefined}>
          {props.error}
        </FormHelperText>
      )}
    </FormControl>
  );
}
